<template>
	<div style="width: 100%;height: 100%;background: #eceef1;">
		<Layout-Top menuName="个人信息" prevUrl="/WeChat/Person">
		</Layout-Top>
		<!-- <Row type="flex" justify="center" align="center" style="height: 46px;width: 100%; background: #eceef1;line-height: 46px;">
			<Col span="2">
				<Icon style="margin-top: -2px;" size="28" type="ios-arrow-back" />
			</Col>
			<Col span="22">
				个人信息  
			</Col>
		</Row> -->
		<div @click="updateHeadImg" style="width: 100%;height:66px ;background: #f8f8f9;line-height: 66px;margin-bottom: 1px;">
			<Row type="flex" justify="center" align="center" >
				<Col span="6" style="padding-left: 16px;">
					头像
				</Col>
				<Col span="16" style="text-align: right;padding-top: 6px;">
					<img src="../../../../../assets/image/wx_sys.png" style="width: 56px;height: 56px;" />
					<Upload
						ref="HeadImg"
						name="idcardFile"
						:show-upload-list="false"
						:on-success="uploadSuccess"
						:before-upload="prevUpload"
						:format="['jpg','jpeg','png']"
						:action="uploadUrl"
						style="display: none;"
						>
					</Upload>
				</Col>
				<Col span="2">
					<Icon style="margin-top: -2px;" size="28" type="ios-arrow-forward" />
				</Col>
			</Row>
		</div>
		<div @click="toPage('/WeChat/Person/Info/Alias')">
			<Row type="flex" justify="center" align="center" style="height: 56px;width: 100%; background: #f8f8f9;line-height: 56px;">
				<Col span="6" style="padding-left: 16px;">
					昵称
				</Col>
				<Col span="16" style="text-align: right;">
					{{person.palias}}
				</Col>
				<Col span="2">
					<Icon style="margin-top: -2px;" size="28" type="ios-arrow-forward" />
				</Col>
			</Row>
		</div>
		<Row type="flex" justify="center" align="center" style="height: 0px;">
			<Col span="3">
				
			</Col>
			<Col span="21">
				<Divider style="margin-top: 0px;" />
			</Col>
		</Row>
		<Row type="flex" justify="center" align="center" style="height: 56px;width: 100%; background: #f8f8f9;line-height: 56px;">
			<Col span="6" style="padding-left: 16px;">
				ID
			</Col>
			<Col span="17" style="text-align: right;">
				{{person.pid}}
			</Col>
			<Col span="1">
			</Col>
		</Row>
		<Row type="flex" justify="center" align="center" style="height: 0px;">
			<Col span="3">
			</Col>
			<Col span="21">
				<Divider style="margin-top: 0px;" />
			</Col>
		</Row>
		
		<div @click="toPage('/WeChat/Person/Info/More')">
			<Row type="flex" justify="center" align="center" style="height: 56px;width: 100%; background: #f8f8f9;line-height: 56px;margin-bottom: 1px;">
				<Col span="6" style="padding-left: 16px;">
					更多
				</Col>
				<Col span="16" style="text-align: right;">
				</Col>
				<Col span="2">
					<Icon style="margin-top: -2px;" size="28" type="ios-arrow-forward" />
				</Col>
			</Row>
		</div>
		
		<div @click="toPage('/WeChat/Person/Info/Address')">
			<Row type="flex" justify="center" align="center" style="height: 56px;width: 100%; background: #f8f8f9;line-height: 56px;margin-top: 8px;">
				<Col span="6" style="padding-left: 16px;">
					我的地址
				</Col>
				<Col span="16" style="text-align: right;">
				</Col>
				<Col span="2">
					<Icon style="margin-top: -2px;" size="28" type="ios-arrow-forward" />
				</Col>
			</Row>
		</div>
	</div>
</template>
<script>
	import Top from '../assembly'
	export default {
		components: {
			'Layout-Top': Top
		},
		data(){
			return {
				uploadUrl:'',
				person:{
					pid:'gdfsdfdf123',
					palias:'有心人。',
					psex:'1'
					
				}
			}
		},
		methods:{
			prevUpload(){
				
			},
			uploadSuccess(){
				
			},
			updateHeadImg(){
				this.$refs.HeadImg.handleClick();
			},
			toPage(page){
				this.$router.push(page);
			}
		}
	}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/views/WeChat/Person/Info/index.vue